"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_localization_1 = tslib_1.__importDefault(require("react-localization"));
var locale = new react_localization_1.default({
    en: {
        repositionFailedError: "Failed to reposition please try again",
        columnResizeTitle: "Column Resize",
        columnResizeDesc: "You have resized {0} column. Would you like to save this change.",
        columnRestored: "Columns restored",
        filtersRestored: "Filters restored",
        filtersSaved: "Table filters saved",
        action: "Action",
        search: "Search...",
        done: "Done",
        emptyTable: "No records found",
        true: "True",
        false: "False",
        selectSearchTitle: "Search to Select",
        conditionTrue: "true",
        conditionFalse: "False",
        conditionLessThanEqual: "less than or equals to",
        conditionLessThan: "less than",
        conditionGreaterThanEqual: "greater than or equals to",
        conditionGreaterThan: "greater than",
        conditionEquals: "equals",
        conditionIcontains: "contains",
        conditionContains: "contains",
        conditionIregex: "regex",
        conditionIsnull: "true",
        conditionSearch: "search",
        conditionIstartswith: "starts with",
        conditionIn: "in",
        confirmMsg: "Do you want to proceed",
        yes: "Yes",
        no: "No",
        fetchingRecordsMsg: "Fetching records...",
        manageColumns: "Manage columns",
        close: "Close",
        resetDefault: "Reset to default",
        save: "Save",
        visibleColumns: "Visible columns",
        reorderColumns: "Reorder columns",
        dragToReorderColumns: "Drag to re-order table columns",
        selectValue: "Select a value",
        filters: "Filters",
        filter: "Filter",
        addFilter: "Add filter",
        confirmSave: "Are you sure you want to save as default filters settings",
        alreadySaved: "Already saved",
        unsavedFilter: "Save this filter as default",
        restoreMsg: "Are you sure you want to restore filters",
        clearFilters: "Clear filters",
        isBetween: "is between {0} - {1}",
        today: "Today",
        tomorrow: "Tomorrow",
        thisWeek: "This week",
        nextWeek: "Next week",
        thisMonth: "This month",
        nextMonth: "Next month",
        import: "Import",
        export: "Export",
        markColumn: "Mark the columns you want to see",
        enterText: "Enter text",
    },
    et: {
        repositionFailedError: "Ümberpaigutamine ebaõnnestus, proovige uuesti",
        columnResizeTitle: "Veeru suuruse muutmine",
        columnResizeDesc: "Olete muutnud veeru {0} suurust. Kas soovite selle muudatuse salvestada.",
        columnRestored: "Veerud taastatud",
        filtersRestored: "Filtrid taastatud",
        filtersSaved: "Tabelifiltrid on salvestatud",
        action: "Tegevus",
        search: "Otsi...",
        emptyTable: "Kirjeid ei leitud",
        true: "Tõsi",
        false: "False",
        selectSearchTitle: "Otsi valimiseks",
        conditionTrue: "tõene",
        conditionFalse: "False",
        conditionLessThanEqual: "vähem kui või võrdne",
        conditionLessThan: "vähem kui",
        conditionGreaterThanEqual: "suurem või võrdne",
        conditionGreaterThan: "suurem kui",
        conditionEquals: "võrdub",
        conditionIcontains: "sisaldab",
        conditionContains: "sisaldab",
        conditionIregex: "regex",
        conditionIsnull: "true",
        conditionSearch: "otsing",
        conditionIstartswith: "starts with",
        conditionIn: "in",
        import: "Import",
        confirmMsg: "Kas soovite jätkata",
        unableToLoadFilter: "ei saa filtreid laadida, filtritee määratletud võti on kehtetu",
        yes: "jah",
        no: "ei",
        fetchingRecordsMsg: "Kirjete toomine...",
        manageColumns: "Veergude haldamine",
        resetDefault: "Lähtesta vaikeseadetele",
        save: "Salvesta",
        visibleColumns: "Nähtavad veerud",
        reorderColumns: "Järjesta veerud ümber",
        dragToReorderColumns: "Tabeli veergude ümberjärjestamiseks lohistage",
        selectValue: "Vali väärtus",
        filters: "Filtrid",
        filter: "Filter",
        addFilter: "Lisa filter",
        confirmSave: "Kas soovite kindlasti salvestada filtrite vaikeseadetena",
        alreadySaved: "Juba salvestatud",
        unsavedFilter: "Salvesta see filter vaikimisi",
        restoreMsg: "Kas soovite kindlasti filtreid taastada",
        clearFilters: "Tühjenda filtrid",
        isBetween: "on vahemikus {0} kuni {1}",
        today: "Täna",
        tomorrow: "Homme",
        thisWeek: "See nädal",
        nextWeek: "järgmisel nädalal",
        thisMonth: "See kuu",
        nextMonth: "Järgmine kuu",
        export: "Eksport",
        close: "Sule",
        done: "Valmis",
        markColumn: "Märkige veerud, mida soovite näha",
        enterText: "Sisestage tekst",
    },
    ru: {
        repositionFailedError: "Не удалось изменить положение. Повторите попытку.",
        columnResizeTitle: "Изменение размера столбца",
        columnRestored: "Columns restored",
        filtersRestored: "Фильтры восстановлены",
        filtersSaved: "Фильтры таблицы сохранены",
        action: "Действие",
        search: "Поиск...",
        done: "Сделано",
        emptyTable: "Результатов не найдено",
        true: "Истина",
        false: "ЛОЖНО",
        selectSearchTitle: "Найдите, чтобы выбрать",
        conditionTrue: "Истина",
        conditionFalse: "ЛОЖНО",
        conditionLessThanEqual: "меньше чем или равно",
        conditionLessThan: "меньше, чем",
        conditionGreaterThanEqual: "больше чем или равно",
        conditionGreaterThan: "больше чем",
        conditionEquals: "равно",
        conditionIcontains: "содержит",
        conditionContains: "содержит",
        conditionIregex: "регулярное выражение",
        conditionIsnull: "пусто",
        conditionSearch: "поиск",
        conditionIstartswith: "начинается с",
        conditionIn: "в",
        confirmMsg: "Вы хотите продолжить",
        yes: "Да",
        no: "Нет",
        fetchingRecordsMsg: "Fetching records...",
        manageColumns: "Управление столбцами",
        close: "Закрыть",
        resetDefault: "сбросить настройки по умолчанию",
        save: "Сохранить",
        visibleColumns: "Видимые столбцы",
        reorderColumns: "Изменить порядок столбцов",
        dragToReorderColumns: "Перетащите, чтобы изменить порядок столбцов таблицы",
        selectValue: "Выберите значение",
        filters: "Фильтры",
        filter: "Фильтр",
        addFilter: "Добавить фильтр",
        confirmSave: "Вы уверены, что хотите сохранить настройки фильтров по умолчанию?",
        alreadySaved: "Уже сохранено",
        unsavedFilter: "Сохранить этот фильтр по умолчанию",
        restoreMsg: "Вы уверены, что хотите восстановить фильтры?",
        clearFilters: "Очистить фильтры",
        isBetween: "находится между {0} – {1}",
        today: "Сегодня",
        tomorrow: "Завтра",
        thisWeek: "Текущая Неделя",
        nextWeek: "Следующая неделя",
        thisMonth: "Текущий месяц",
        nextMonth: "Следующий месяц",
        import: "Импорт",
        export: "Сохранить файл",
        markColumn: "Отметьте столбцы, которые вы хотите видеть",
        enterText: "Ввести текст",
    },
    lv: {
        repositionFailedError: "Neizdevās pārvietot, lūdzu, mēģiniet vēlreiz",
        columnResizeTitle: "Kolonnas lieluma maiņa",
        columnRestored: "Columns restored",
        filtersRestored: "Filtri atjaunoti",
        filtersSaved: "Tabulas filtri ir saglabāti",
        action: "Notikums",
        search: "Meklēt...",
        done: "Pabeigts",
        emptyTable: "Nav rezultātu",
        true: "Taisnība",
        false: "Nekorekti",
        selectSearchTitle: "Meklēt, lai atlasītu",
        conditionTrue: "taisnība",
        conditionFalse: "nekorekti",
        conditionLessThanEqual: "mazāks vai vienāds ar",
        conditionLessThan: "mazāk nekā",
        conditionGreaterThanEqual: "lielāks vai vienāds ar",
        conditionGreaterThan: "lielāks par",
        conditionEquals: "vienāds",
        conditionIcontains: "satur",
        conditionContains: "satur",
        conditionIregex: "regex",
        conditionIsnull: "tukšs",
        conditionSearch: "meklēt",
        conditionIstartswith: "sākas ar",
        conditionIn: "iekšā",
        confirmMsg: "Vai vēlaties turpināt",
        yes: "Jā",
        no: "Nē",
        fetchingRecordsMsg: "Fetching records...",
        manageColumns: "Pārvaldīt kolonnas",
        close: "Aizvērt",
        resetDefault: "Noklusējuma iestatījumi",
        save: "Saglabāt",
        visibleColumns: "Redzamās kolonnas",
        reorderColumns: "Pārkārtot kolonnas",
        dragToReorderColumns: "Velciet, lai pārkārtotu tabulas kolonnas",
        selectValue: "Izvēlieties vērtību",
        filters: "Filtri",
        filter: "Filtrs",
        addFilter: "Pievienot filtru",
        confirmSave: "Vai tiešām vēlaties saglabāt kā noklusējuma šo filtru?",
        alreadySaved: "Ir saglabāts",
        unsavedFilter: "Saglabājiet šo filtru kā noklusējumu",
        restoreMsg: "Atsaukt filtrus",
        clearFilters: "Notīrīt filtrus",
        isBetween: "ir starp {0} - {1}",
        today: "Šodien",
        tomorrow: "Rītdien",
        thisWeek: "Šī Nedēļa",
        nextWeek: "Nākamā nedēļa",
        thisMonth: "Šis Mēnesis",
        nextMonth: "Nakamais Mēnesis",
        import: "Importēt",
        export: "Exportēt",
        markColumn: "Atzīmējiet kolonnas, kuras vēlaties redzēt",
        enterText: "Ievadiet tekstu",
    },
    pl: {
        repositionFailedError: "Nie udało się zmienić położenia, spróbuj ponownie",
        columnResizeTitle: "Zmiana rozmiaru kolumny",
        columnRestored: "Columns restored",
        filtersRestored: "Filtry odnowione",
        filtersSaved: "Zapisano filtry tabeli",
        action: "Działanie",
        search: "Szukaj...",
        done: "Zrobione",
        emptyTable: "Brak wyników",
        true: "prawda",
        false: "nieprawidłowy",
        selectSearchTitle: "Wyszukaj, aby wybrać",
        conditionTrue: "Prawda",
        conditionFalse: "Nieprawidłowy",
        conditionLessThanEqual: "mniejszy lub równy",
        conditionLessThan: "mniej niż",
        conditionGreaterThanEqual: "większy lub równy",
        conditionGreaterThan: "większe niż",
        conditionEquals: "równa się",
        conditionIcontains: "zawiera",
        conditionContains: "zawiera",
        conditionIregex: "wyrażenie regularne",
        conditionIsnull: "jest pusty",
        conditionSearch: "Szukaj",
        conditionIstartswith: "zaczynać od",
        conditionIn: "w",
        confirmMsg: "Czy chcesz kontynuować",
        yes: "Tak",
        no: "Nie",
        fetchingRecordsMsg: "Fetching records...",
        manageColumns: "Zarządzaj kolumnami",
        close: "Zamknij",
        resetDefault: "Przywróć ustawienia domyślne",
        save: "Zapisz",
        visibleColumns: "Widoczne kolumny",
        reorderColumns: "Zmień kolejność kolumn",
        dragToReorderColumns: "Przeciągnij, aby zmienić kolejność kolumn tabeli",
        selectValue: "Wybierz wartość",
        filters: "Filtry",
        filter: "Filtr",
        addFilter: "Dodaj filtr",
        confirmSave: "Czy na pewno chcesz zapisać jako domyślne ustawienia filtrów?",
        alreadySaved: "Już zapisane",
        unsavedFilter: "Zapisz ten filtr jako domyślny",
        restoreMsg: "Czy na pewno chcesz przywrócić filtry?",
        clearFilters: "Wyczyść filtry",
        isBetween: "jest między {0} - {1}",
        today: "Dziś",
        tomorrow: "Jutro",
        thisWeek: "Ten Tydzień",
        nextWeek: "Następny tydzień",
        thisMonth: "Ten Miesiąc",
        nextMonth: "W następnym miesiącu",
        import: "Importuj",
        export: "Eksport",
        markColumn: "Zaznacz kolumny, które chcesz zobaczyć",
        enterText: "Wprowadź tekst",
    },
});
exports.default = locale;
//# sourceMappingURL=locale.js.map